import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './GridContainer.module.scss.js';

const { componentTestLabel } = getTestLabels('GridContainer');
/**
 * [design (Figma)](https://www.figma.com/file/ZxcgCXonHvmYETNpUB95wQ/Foundations-WIP?type=design&node-id=5729-90184&mode=design&t=8zT81DV1bMLRXSVN-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/GridContainer/GridContainer.tsx)
 *
 * @param {object} gridTemplateColumns - specifies the `grid-template-columns` property at specific breakpoints (see MDN docs[https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns])
 */
const GridContainer = forwardRef((props, ref) => {
    const { children, gridTemplateColumns, ...otherProps } = props;
    let styles = {};
    let gridTemplateColumnsObject = {};
    if (gridTemplateColumns) {
        gridTemplateColumnsObject = gridTemplateColumns;
    }
    if (gridTemplateColumns) {
        Object.keys(gridTemplateColumnsObject).forEach((key) => {
            styles = {
                ...styles,
                [`--pp-GridContainer-gridTemplateColumns${key === 'default' ? '' : `--bp-${key}`}`]: gridTemplateColumnsObject[key],
            };
        });
    }
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['pp-GridContainer']), style: styles, children: children }));
});
GridContainer.displayName = 'GridContainer';

export { GridContainer };
//# sourceMappingURL=GridContainer.js.map
